import { render, staticRenderFns } from "./CourseStructureTree.vue?vue&type=template&id=12209dcc&scoped=true"
import script from "./CourseStructureTree.js?vue&type=script&lang=js&external"
export * from "./CourseStructureTree.js?vue&type=script&lang=js&external"
import style0 from "./CourseStructureTree.vue?vue&type=style&index=0&id=12209dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12209dcc",
  null
  
)

export default component.exports